<template>
    <div>
        <b-field :label="label" label-position="inside">
            <b-select v-model="choice" expanded>
                <option v-for="option in options" :value="option">{{ option }}</option>
            </b-select>
        </b-field>
        <b-field v-if="choice === selfDescribe" label="My gender is..." label-position="inside" class="mt-2">
            <b-input v-model="custom"></b-input>
        </b-field>
    </div>
</template>

<script>
    import {GENDER_OPTIONS} from "@/constants/profile";

    const SELF_DESCRIBE = 'Prefer to self-describe';

    // v-model wrapper around the gender select. Choosing "Prefer to
    // self-describe" reveals a free-text input; whatever the user types is
    // what gets stored, so any pre-existing value not in the list round-trips
    // back into the text input on load.
    export default {
        name: "GenderField",
        props: {
            value: String,
            label: {type: String, default: 'Gender'}
        },
        data: function() {
            return {
                options: GENDER_OPTIONS,
                selfDescribe: SELF_DESCRIBE,
                choice: null,
                custom: null
            };
        },
        watch: {
            value: {
                immediate: true,
                handler: function(val) {
                    if (!val) return;
                    if (this.options.includes(val)) {
                        this.choice = val;
                    } else {
                        this.choice = SELF_DESCRIBE;
                        this.custom = val;
                    }
                }
            },
            choice: function() {
                this.emitValue();
            },
            custom: function() {
                this.emitValue();
            }
        },
        methods: {
            emitValue: function() {
                const out = (this.choice === SELF_DESCRIBE) ? (this.custom || '') : this.choice;
                if (out !== this.value) this.$emit('input', out);
            }
        }
    };
</script>
